export default __webpack_public_path__ + "static/media/close-icon-gray.cf408d70.svg";